// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-max-type */
.V96eTMauHP8kTH {
  bottom: var(--ds-space-200, 16px);
  transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}
.V96eTMauHP8kTH.fKbeKeWe8c33wz {
  bottom: -100px;
}
.V96eTMauHP8kTH.Zfon2urYIUf4eI {
  transform: translateY(100px);
  opacity: 0;
  pointer-events: none;
}
.h38TalBaid8h4h {
  bottom: var(--ds-space-0, 0);
  box-sizing: border-box;
  align-items: center;
  height: var(--ds-space-800, 64px);
  border-top: 1px solid var(--ds-border, #dfe3e8);
}
.h38TalBaid8h4h > div > div:last-child {
  flex: 0 0 36px;
}
.pnckPRb_ipCsUw span:has(svg) {
  position: relative;
}
.pnckPRb_ipCsUw span:has(svg)::after {
  content: '';
  position: absolute;
  top: -4px;
  right: -4px;
  box-sizing: inherit;
  width: 8px;
  height: 8px;
  border: 2px solid var(--ds-icon-inverse, #ffffff);
  border-radius: var(--ds-border-radius-circle, 100%);
  background-color: var(--ds-background-discovery-bold, #6e5dc6);
}
`, ""]);
// Exports
export var configurationPanels = `V96eTMauHP8kTH`;
export var isCardRoute = `fKbeKeWe8c33wz`;
export var hiddenForBulkActions = `Zfon2urYIUf4eI`;
export var configurationTabs = `h38TalBaid8h4h`;
export var hasNotifications = `pnckPRb_ipCsUw`;
export default ___CSS_LOADER_EXPORT___;
